import { __assign } from "tslib";
import { Menu, } from '@fluentui/react-components';
import React, { useCallback, useMemo } from 'react';
import { ActionContextMenuPopover } from './ActionContextMenuPopover';
import { ActionMenuTrigger } from './ActionMenuTrigger';
/**
 * A context, triggered, or, triggered Fluent v9 menu.
 *
 * @param param0 IActionContextMenuControlProps
 * @returns A Fluent v9 context menu control
 */
export var ActionContextMenuControl = function (_a) {
    var defaultOpen = _a.defaultOpen, groupInfo = _a.groupInfo, items = _a.items, target = _a.target, onActionMenuToggled = _a.onActionMenuToggled, open = _a.open, triggerOptions = _a.triggerOptions;
    // log event when ActionContextMenuControl prop defaultOpen is set to true
    if (defaultOpen && onActionMenuToggled) {
        onActionMenuToggled(true);
    }
    // Allow parent to handle closing the menu (return null)
    var onOpenChange = useCallback(function (_e, data) {
        if (onActionMenuToggled) {
            onActionMenuToggled(data.open);
        }
    }, [onActionMenuToggled]);
    /**
     * Create a 'VirtualElement' to anchor the context menu to.
     * This replicates some of the logic from @fluentui/react-positioning
     * https://github.com/microsoft/fluentui/tree/master/packages/react-positioning
     * Reference: https://github.com/microsoft/fluentui/blob/master/packages/react-positioning/src/createVirtualElementFromClick.ts
     */
    var positioning = useMemo(function () {
        if (target instanceof MouseEvent) {
            var left_1 = target.clientX;
            var top_1 = target.clientY;
            var right_1 = left_1 + 1;
            var bottom_1 = top_1 + 1;
            return {
                target: {
                    getBoundingClientRect: function () {
                        return {
                            left: left_1,
                            top: top_1,
                            right: right_1,
                            bottom: bottom_1,
                            height: 1,
                            width: 1,
                            // Do not pass x,y,toJSON. Type for ClientRect is deprecated and contains
                            // everything that DOMRect does.
                        };
                    },
                    contextElement: undefined,
                },
            };
        }
        if (target instanceof HTMLElement) {
            return {
                target: {
                    getBoundingClientRect: target.getBoundingClientRect.bind(target),
                    contextElement: target,
                },
            };
        }
        return undefined;
    }, [target]);
    return (React.createElement(Menu, { defaultOpen: defaultOpen, onOpenChange: onOpenChange, open: open, positioning: positioning },
        React.createElement(ActionMenuTrigger, __assign({}, triggerOptions)),
        React.createElement(ActionContextMenuPopover, { items: items, groupInfo: groupInfo })));
};
//# sourceMappingURL=ActionContextMenuControl.js.map